package com.thanawyamarathon

import react.dom.client.createRoot
import web.dom.document
import web.dom.ElementId
import react.create

fun main() {
    val container = document.getElementById(ElementId("root")) ?: error("No root element found")
    createRoot(container).render(ReactApp.create())
}
